/*global google*/
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";
import axios from "axios";

const containerStyle = {
  width: "140vh",
  height: "55vh",
};

const center = {
  lat: 23.023365067899896,
  lng: 72.50708810985088,
};

function SingleCropSurveyView() {
  const [map, setMap] = useState(null);
  const { state } = useLocation();
  const [flag, setFlag] = useState(false);
  const navigate = useNavigate();
  const [cropSurveyData, setCropSurveyData] = useState("");
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
  googleMapsApiKey : "AIzaSyAr-n9zN3vYDBaPtINPgPQi70DGtHUiyfE"
  });

  useEffect(() => {
    if (state) {
      setCropSurveyData(state.CropDemonstrationCode);
      setFlag(true);
    }
  });

  const onLoad = React.useCallback(function callback(map) {
    function firstFunction1() {
      return new Promise((resolve, reject) => {
        resolve(state.CropDemonstrationCode);
      });
    }

    async function secondFunction1() {
      const result = await firstFunction1();
      const polygonData = JSON.parse(result.geoPlotting)
     
      map.setCenter(new google.maps.LatLng(polygonData[0].lat, polygonData[0].lng));
      let mmyPolygon = new window.google.maps.Polygon({
        paths: polygonData,
        strokeColor: "#FF0000",
        strokeOpacity: 1,
        strokeWeight: 2,
        fillColor: "#FF0000",
        fillOpacity: 0.1,
         content: `<div id="infoContent"> <span> <strong><b>Crop Demonstration Details - </b></strong> </span></br> <span><strong>State Name : </strong></span><span>${result.stateName}</span></br><span><strong>District Name : </strong></span><span>${result.districtName}</span></br><span><strong>Season Name : </strong></span><span>${result.seasonName}</span></br><span><strong>Farmer Name : </strong></span><span>${result.farmerName}</span></br><span><strong>Crop Demonstration Code: </strong></span><span>${result.cropDemonstrationCode}</span></br></div>`,
      });
      mmyPolygon.setMap(map);
      let myInfoWindow = new google.maps.InfoWindow;
      mmyPolygon.addListener('mouseover', function (event) {
          mmyPolygon.setEditable(!mmyPolygon.getEditable());
          myInfoWindow.setContent(this.content);
          myInfoWindow.setPosition(event.latLng);
          myInfoWindow.open(map);
      });
      mmyPolygon.addListener('mouseout', function (event) {
          myInfoWindow.close();
      });
    
      
    }
    secondFunction1();
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  return isLoaded ? (
    <>

      <main id="main" className="main">
        <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
          <nav>
            <h1>Crop Demonstration Details</h1>
           
            <ol className="breadcrumb">
              <li className="breadcrumb-item">Crop Demonstration Details</li>
              <li className="breadcrumb-item active">View</li>
            </ol>
          </nav>
          <button
            type="button"
            className="btn btn-success"
            onClick={() => navigate("/nfsm/cropdemonstration")}
          >
            <FontAwesomeIcon icon={faArrowLeft} /> Back
          </button>
        </div>
        <section>
          <div className="card">
            <div className="card-body">
              <div className="container-fluid">
                <div class="formgroupss">
                  <h5 class="formgrouping">Crop Demonstration Details</h5>{" "}
                  <div class="row">
                    <div class="col-md-4">
                      <label>Crop Demonstration Code :</label>
                      {state.CropDemonstrationCode.cropDemonstrationCode}{" "}
                    </div>
                    <div class="col-md-4">
                      <label>Crop Demonstration RefID :</label>{" "}
                      {state.CropDemonstrationCode.cropDemonstrationRefID}
                    </div>
                    <div class="col-md-4">
                      <label>Farmer Name :</label>
                      {state.CropDemonstrationCode.farmerName}{" "}
                    </div>
                    <div class="col-md-4">
                      <label>Father Spouses Name :</label>
                      {state.CropDemonstrationCode.fatherSpousesName}{" "}
                    </div>
                    <div class="col-md-4">
                      <label>Mobile No. :</label>
                      {state.CropDemonstrationCode.mobileNo}{" "}
                    </div>
                    <div class="col-md-4">
                      <label>Gender :</label> {state.CropDemonstrationCode.gender === "M" ? "Male" : "Female"}{" "}
                    </div>

                    <div class="col-md-4">
                      <label>Age Range :</label>
                      {state.CropDemonstrationCode.ageRange}{" "}
                    </div>
                    {/* <div class="col-md-4"><label>Surveyor ID :</label> {state.CropDemonstrationCode.farmerName1}</div> */}
                    <div class="col-md-4">
                      <label>Caste Category :</label>
                      {state.CropDemonstrationCode.casteCategory}{" "}
                    </div>
                    <div class="col-md-4">
                      <label> Khasra No. :</label>
                      {state.CropDemonstrationCode.khasraNo}{" "}
                    </div>
                    <div class="col-md-4">
                      <label>Demonstration :</label>
                      {state.CropDemonstrationCode.demonstration}{" "}
                    </div>
                    {state.CropDemonstrationCode.cropDemonstrationVal ? <div class="col-md-4">
                      <label>Crop Demonstration Value :</label>{" "}
                      {state.CropDemonstrationCode.cropDemonstrationVal}{" "}
                    </div> : ''}

                    <div class="col-md-4">
                      <label>Financial Year :</label>
                      {state.CropDemonstrationCode.finYears}{" "}
                    </div>
                    <div class="col-md-4">
                      <label>State Name :</label>{" "}
                      {state.CropDemonstrationCode.stateName}
                    </div>
                    <div class="col-md-4">
                      <label>District Name :</label>
                      {state.CropDemonstrationCode.districtName}{" "}
                    </div>
                    <div class="col-md-4">
                      <label>Block Name :</label>
                      {state.CropDemonstrationCode.blockName}{" "}
                    </div>
                    <div class="col-md-4">
                      <label>Village Name :</label>{" "}
                      {state.CropDemonstrationCode.villageName}{" "}
                    </div>

                    <div class="col-md-4">
                      <label>Area Under Demonstration :</label>
                      {state.CropDemonstrationCode.areaUnderDemonstration}{" "}
                    </div>
                    <div class="col-md-4">
                      <label>Season Name :</label>{" "}
                      {state.CropDemonstrationCode.seasonName}
                    </div>
                    {/* <div class="col-md-4"><label>Area Unit :</label>{state.CropDemonstrationCode.areaUnit} </div> */}
                    {/* <div class="col-md-4"><label>Mansoon Crop Code :</label>{state.CropDemonstrationCode.mansoonCropCode} </div> */}
                    <div class="col-md-4">
                      <label>Demonstration Type :</label>
                      {state.CropDemonstrationCode.demonstrationType}{" "}
                    </div>
                    <div class="col-md-4">
                      <label>Source Of Irrigation :</label>{" "}
                      {state.CropDemonstrationCode.sourceOfIrrigation}{" "}
                    </div>
                    <div class="col-md-4">
                      <label>Landmark Of The Field :</label>{" "}
                      {state.CropDemonstrationCode.landmarkOfTheField}{" "}
                    </div>
                    <div class="col-md-4">
                      <label>Created Date (YYYY/MM/DD) :</label>{" "}
                      {state.CropDemonstrationCode.createdDate.split("T")[0]}{" "}
                    </div>
                  </div>
                </div>
                
                <h5 className="formgrouping">Crop Demonstration Images</h5>
                <div id="imageDiv">
                  <div>
                    <img
                      // src={
                      //   "http://" +
                      //   state.CropDemonstrationCode.landPhoto 
                      // }

                      // src = {`${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE  : process.env.REACT_APP_PRO_MODE }` + "/"+state.CropDemonstrationCode.landPhoto  }
                    src ="http://naturalfarming.dac.gov.in/NFServices/FarmerAnswerImage/1689942234034.jpg"
                      alt="Inspection Image"
                    />
                    <span> Latitude : {state.CropDemonstrationCode.surveyorLat}</span>
                    <span>
                      {" "}
                      Longitude : {state.CropDemonstrationCode.surveyorLong}
                    </span>
                  </div>
                </div>
                <h5 className="formgrouping">Crop Demonstration Map</h5>

                <div className="col-lg-3 dashboard">
                  <div className="card">
                    <GoogleMap
                      mapContainerStyle={containerStyle}
                      center={center}
                      zoom={18}
                      onLoad={onLoad}
                      onUnmount={onUnmount}
                      mapTypeId="satellite"
                    ></GoogleMap>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  ) : (
    <></>
  );
}

export default React.memo(SingleCropSurveyView);
